import { createBrowserRouter, Navigate } from "react-router-dom";
import AppShell from "./components/AppShell";
import Splash from "./pages/Splash";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetails from "./pages/ProductDetails";
import Schedule from "./pages/Schedule";
import Addresses from "./pages/Addresses";
import OrderReview from "./pages/OrderReview";
import OrderSuccess from "./pages/OrderSuccess";
import Deliveries from "./pages/Deliveries";
import DeliveryDetails from "./pages/DeliveryDetails";
import Subscription from "./pages/Subscription";
import Profile from "./pages/Profile";
import Notifications from "./pages/Notifications";
import Help from "./pages/Help";
import About from "./pages/About";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Admin from "./pages/Admin";

export const router = createBrowserRouter([
  { path: "/", element: <Splash /> },
  { path: "/login", element: <Login /> },
  { path: "/register", element: <Register /> },
  { path: "/admin", element: <Admin /> },
  {
    element: <AppShell />,
    children: [
      { path: "/home", element: <Home /> },
      { path: "/services", element: <Navigate to="/protein-shakes" replace /> },
      { path: "/protein-shakes", element: <Products type="shake" /> },
      { path: "/protein-shakes/:id", element: <ProductDetails /> },
      { path: "/fruits", element: <Products type="fruit" /> },
      { path: "/fruits/:id", element: <ProductDetails /> },
      { path: "/schedule/:type/:id", element: <Schedule /> },
      { path: "/addresses", element: <Addresses /> },
      { path: "/order-review", element: <OrderReview /> },
      { path: "/order-success", element: <OrderSuccess /> },
      { path: "/deliveries", element: <Deliveries /> },
      { path: "/deliveries/:id", element: <DeliveryDetails /> },
      { path: "/subscriptions/:id", element: <Subscription /> },
      { path: "/profile", element: <Profile /> },
      { path: "/notifications", element: <Notifications /> },
      { path: "/help", element: <Help /> },
      { path: "/about", element: <About /> },
      { path: "*", element: <Navigate to="/home" replace /> },
    ],
  },
]);
